<div class="forgot-password-page">
  <app-secondary-logo />

  <div class="forgot-password-page__content">
    <div class="forgot-password-page__form">
      @if (isRequestSuccessful()) {
        <app-forgot-password-success [email]="submittedEmail()" />
      } @else {
        <app-forgot-password-form (success)="onRequestSuccess($event)" />
      }
    </div>

    <div class="forgot-password-page__banner">
      @if (isRequestSuccessful()) {
        <img ngSrc="/assets/images/mail-dynamic.png" alt="Mail" height="480" width="480" />
      } @else {
        <img ngSrc="/assets/images/key-dynamic.png" alt="Key" height="480" width="480" />
      }
    </div>
  </div>
</div>
